import { Route, Routes, useLocation } from "react-router-dom";
import { useState } from "react";
import { PrimeReactProvider } from "primereact/api";
import "./App.css";

import "primereact/resources/themes/lara-light-cyan/theme.css";
import "react-big-calendar/lib/css/react-big-calendar.css";

import SignIn from "./pages/signIn/signIn";
import SignUp from "./pages/signUp/signUp";
import PropertyListing from "./pages/propertyListing/propertyListing";
import PropertyDetail from "./components/propertyDetail/propertyDetail";
import ProtectedRoute from "./components/protectedRoute/protectedRoute";
import Leads from "./pages/leads/leads";
import Contacts from "./pages/contacts/contacts";
import CalendarAppointments from "./pages/calendarAppointments/calendarAppointments";
import Tasks from "./pages/tasks/tasks";
import Agents from "./pages/agents/agents";
import Teams from "./pages/teams/teams";
import PageNotFound from "./pages/pageNotFound/pageNotFound";
import ComingSoon from "./pages/comingSoon/comingSoon";
import Settings from "./pages/settings/settings";

const App = ({ title }) => {
  const [isActive, setIsActive] = useState(true);

  return (
    <PrimeReactProvider value={{ unstyled: false, ripple: true }}>
      <div className="wrapper">
        {isActive && <></>}
        <Routes>
          <Route path="/signin" element={<SignIn setIsActive={setIsActive} />} />
          <Route path="/signup" element={<SignUp setIsActive={setIsActive} />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <ComingSoon title={"Dashboard Page"} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <ComingSoon title={"Dashboard Page"} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/properties/*"
            element={
              <ProtectedRoute>
                <PropertyListing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/property-details/:id"
            element={
              <ProtectedRoute>
                <PropertyDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/leads/*"
            element={
              <ProtectedRoute>
                <Leads />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tasks/*"
            element={
              <ProtectedRoute>
                <Tasks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contacts/*"
            element={
              <ProtectedRoute>
                <Contacts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agents/*"
            element={
              <ProtectedRoute>
                <Agents />
              </ProtectedRoute>
            }
          />
          <Route
            path="/calendar-appointments/*"
            element={
              <ProtectedRoute>
                <CalendarAppointments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/deals-transactions"
            element={
              <ProtectedRoute>
                <ComingSoon title={"Deals & Transactions Page"} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/campaigns"
            element={
              <ProtectedRoute>
                <ComingSoon title={"Campaigns Page"} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client-portal"
            element={
              <ProtectedRoute>
                <ComingSoon title={"Client & Portal Page"} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <ComingSoon title={"Reports Page"} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/document-center"
            element={
              <ProtectedRoute>
                <ComingSoon title={"Document Center Page"} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/team/*"
            element={
              <ProtectedRoute>
                <Teams />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/help-and-support"
            element={
              <ProtectedRoute>
                <ComingSoon title={"Help & Support Page"} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <PageNotFound />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </PrimeReactProvider>
  );
};

export default App;
